export const apiBase = 'https://api.skolia.app/v1';
export const fulfillment = {
  endpoint: `${apiBase}/operations/fulfillment/export`,
  integrationKey: 'skl_ops_5cfb39d7e418a64b7230'
};
